<template>
    <flex-container>
        <realworks-taak-type-select-input
            v-model="formData.taakType"
            @loading="emit('loading')"
            @loaded="emit('loaded')"
        />
    </flex-container>
</template>

<script setup lang="ts">
    import { FlexContainer } from '@keyvue/one-ui';
    import { watch, ref } from 'vue';
    import RealworksTaakTypeSelectInput from '@/shared/components/common-form/RealworksTaakTypeSelectInput.vue';

    interface Props {
        modelValue: {
            taakType: string | null,
        }
    }

    const props = defineProps<Props>();
    const emit = defineEmits<{
        (e: 'loading'): void;
        (e: 'loaded'): void;
        (e: 'update:modelValue', value: any): void;
    }>();

    const formData = ref(props.modelValue);

    watch(() => props.modelValue, (newValue) => {
        Object.assign(formData, newValue);
    }, { deep: true });

    watch(() => formData, () => {
        emit('update:modelValue', formData.value);
    }, { deep: true });
</script>
